/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { IdPhotoUrlResponseUrl } from './idPhotoUrlResponseUrl';

/**
 * Short-lived SAS URL (or None) for the student's uploaded ID photo.
 */
export interface IdPhotoUrlResponse {
  url?: IdPhotoUrlResponseUrl;
}
